import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiHeaders } from "../../lib/apiHeader";
import axios from "axios";
import apis from "../../lib/apis/apis";
import toast from "react-hot-toast";

export const getAllPaymentMethods = createAsyncThunk(
  "getAllpaymentmethods",
  async (data, { dispatch }) => {
    try {
      const response = await axios.get(apis.get_all_payment_methods, {
        headers: apiHeaders(),
      });

      if (response?.data?.success === "true") {
        return response?.data?.data;
      }
      if (response?.data?.success === false) {
        return {
          data: response.data,
          errors: true,
        };
      }
    } catch (err) {
      if (err?.response?.status !== 200) {
        return {
          data: [],
          errors: err?.response?.data?.errors,
        };
      }
    }
  }
);
export const storePaymentMethods = createAsyncThunk('storePaymentMethods', async (data) => {
  try {
    const response = await axios.post(apis.store_payment_methods, {...data},{
      headers: apiHeaders()
    })
    return  response?.data

  }catch (err){
    if (err?.response?.status!==200){
      toast.error(err?.message,{duration:4000})
    }
    if (err?.response?.status!==200){

      return {
        data : [],
        errors:err?.response?.data?.errors
      }
    }
  }
})

export const updatePaymentMethods = createAsyncThunk('updatePaymentMethods', async (data,{dispatch}) => {
  try {
    const response = await axios.post(apis.update_payment_methods, {...data},{
      headers: apiHeaders()
    })

    if (response?.data?.success==='true'){
      await dispatch(getAllPaymentMethods())
      return  response.data
    }else {
      return response?.data
    }
  }catch (err){
    //console.log(err)
    if (err?.response?.status!==200){
      return {
        data :err?.response,
        errors:true
      }
    }
  }
})

export const deletePaymentMethod = createAsyncThunk('deletePaymentMethod', async (id,{dispatch}) => {
  try {
    const response = await axios.get(apis.delete_payment_methods+id,{
      headers: apiHeaders()
    })

    if (response?.data?.success ==='true'){
      await dispatch(getAllPaymentMethods())
      toast.success("Payment method deleted successfully",{duration:3000})

    }else {
      //console.log(response?.data)
    }

  }catch (err){
    //console.log(err)
    if (err?.response?.status!==200){
      toast.error(err?.message,{duration:4000})
    }
  }
})
export const getPaymentMethodsByID = createAsyncThunk('getPaymentMethodsByID', async (id) => {
  try {
    const response = await axios.get(apis.get_payment_methods_by_id+id,{
      headers: apiHeaders()
    })
    return  response?.data

  }catch (err){
    if (err?.response?.status!==200){
      return {
        data : [],
        errors:err?.response?.data?.errors
      }
    }
  }
})

export const paymentMethodsSlice = createSlice({
  name: "paymentMethodsSlice",
  initialState: {
    paymentMethods: [],
    meta: {},
    links: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllPaymentMethods.fulfilled, (state, action) => {
      state.paymentMethods = action.payload;
      state.meta = action.payload.meta;
      state.links = action.payload.links;
    });
  },
});

export default paymentMethodsSlice.reducer;
